const csvTemplate = `outlet_code,tax_name,tax_number,pkp,wht
TGR1-10625-0211712-000,Mr. Ahmad,0000000000000000,TRUE,npwp_badan
TGR1-10625-0211713-000,Mr. Charlie,1234567891011121,FALSE,npwp_pribadi`;

export default csvTemplate;
